// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-48fca73c] .agb{font-family:\"Heebo\",-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif!important}[data-v-48fca73c] .agb ul{padding-bottom:1em}[data-v-48fca73c] .agb ol{padding-top:1em}[data-v-48fca73c] .agb h2{padding-bottom:1em}[data-v-48fca73c] .agb :before{left:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
